import type { CanCreateCodeResponse } from '@polaris/core/services'
import { kyApiClient } from '@polaris/core/utils'

export const canCreateCode = (code: string, userId?: string) =>
  kyApiClient
    .get(`api/v1/referral/can-create/${code}`, {
      searchParams: userId ? { user_id: userId } : {},
    })
    .json<CanCreateCodeResponse>()
